import { Dispatch } from 'redux'
import { addServicesToForm } from '../../../actions/bookingCalendar/reservationModal/addServicesToForm'

export default function(form) {
  return function(values: any, dispatch: Dispatch) {
    dispatch(addServicesToForm(values, form))
  }
}
